import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: routes.ERROR,
    name: 'ERROR',
    component: () => import('@app/pages/ErrorPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NOT_FOUND',
    component: () => import('@app/pages/NotFoundPage.vue'),
  },
]
